const getConfig = () => {
  return {
    columns: [
      {
        title: '适用产品',
        dataIndex: 'productName',
        width: 160,
        ellipsis: true,
      },
      {
        title: '适用门店',
        dataIndex: 'shopName',
        width: 160,
        ellipsis: true,
        render: (v, record) => record.shopId === '0' ? '通用' : v
      },
      {
        title: '毛利最低(%)',
        dataIndex: 'minValue',
        width: 100,
        render: (v) => <div style={{textAlign: 'right'}}>{v}</div>,
      },
      {
        title: '毛利最高(%)',
        dataIndex: 'maxValue',
        width: 100,
        render: (v) => <div style={{textAlign: 'right'}}>{v}</div>,
      },
      {
        title: '创建人',
        dataIndex: 'createdByName',
        width: 160,
      },
      {
        title: '创建时间',
        dataIndex: 'createdTime',
        itemType: 'dateTime',
        width: 160,
      },
      {
        title: '操作',
        dataIndex: '#',
        width: 160,
        fixed: 'right',
        render: 'actionRender'
      },
    ],
    search: [
      {
        label: '适用产品',
        name: 'productId',
        itemType: 'custom',
        render: 'searchSelectRender'
      },
      {
        name: 'shopId',
        label: '适用门店',
        itemType: 'select',
        data: 'companyList',
        labelKey: 'name',
        key: 'id',
      },
    ],
    footer: [
      {
        label: '新增配置',
        type: 'primary',
        events: ['onClick:onAdd']
      }
    ],
    batchActions: [
      {
        label: '删除',
        events: ['onClick:onBatchDel']
      }
    ]
  }
}

export {getConfig}